import React, {useEffect, useState} from 'react';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Button, Card, CardBody, Col, Row} from "reactstrap";
import {connect} from "react-redux";
import { getLog, getLogs} from "../../store/log/actions";
import LogList from "./List/LogList";
import Paging from "../../components/Pagination/Pagination";
import { Space} from "antd";
import Search from "components/Search/Search";
import ListSearch from "components/ListSearch/ListSearch";

const emptySearch = () => ({filter: '', text: '', tagsFilters: {}})

// The filter modal's criteria only count once a field has a value or a tag
// is picked; an untouched modal must not send an empty `search` param.
const hasActiveFilter = (search) =>
  Boolean((search.text && search.filter) || Object.keys(search.tagsFilters).length)

const Logs = ({getLogs, logsList}) => {

  const [currentPage, setCurrentPage] = useState(1)
  const [filterModalOpen, setFilterModalOpen] = useState(false)
  const [search, setSearch] = useState(emptySearch)
  const [q, setQ] = useState('')
  const options = [
    {keySearch: 'parentID.name_parentID.surname', titleSearch: 'Име'},
    {keySearch: 'ipAddress', titleSearch: 'IP адрес'},
    {keySearch: 'createdAt', titleSearch: 'Дата на създаване'},

  ]

  // The one place the list is fetched: page, free-text term and modal filter
  // are all state, so changing any of them refetches once with all three.
  useEffect(() => {
    getLogs({page: currentPage, q, ...(hasActiveFilter(search) && {search})})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, q, search])

  const refreshPage = () => {
    setSearch(emptySearch())
    setCurrentPage(1)
  }

  const onSubmit = (e, search) => {
    e.preventDefault()
    setSearch({...search})
    setCurrentPage(1)
    setFilterModalOpen(false)
  }

  const handleTextSearch = (value) => {
    setQ(value)
    setCurrentPage(1)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Одитен журнал" breadcrumbItem="Одитен журнал"/>

          <Row>
            <Col>
              <Card>
                <div className="list-toolbar py-2">
                  <Paging setPage={setCurrentPage} currentPage={currentPage} pages={logsList?.pages}/>
                  <ListSearch
                    value={q}
                    onSearch={handleTextSearch}
                    placeholder="Търсене по име или IP адрес"
                  />
                  <Space direction="horizontal" className="mr-4">
                    <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                            onClick={() => setFilterModalOpen(!filterModalOpen)}><i
                      className="bx bx-filter-alt align-middle"></i></Button>
                    {(search.text || Object.keys(search.tagsFilters).length > 0) &&
                      <Button type={'button'} className='btn btn-dark waves-effect waves-light search-btn'
                              onClick={refreshPage}><i
                        className='bx bx-revision align-middle'></i></Button>}
                  </Space>
                </div>
                <CardBody>

                  <LogList
                    list={logsList?.logs}
                  />
                </CardBody>
                <Paging setPage={setCurrentPage} currentPage={currentPage} pages={logsList?.pages}/>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Search searchModalOpen={filterModalOpen}
              options={options}
              filterData={['createdAt']}
              searchVar={search}
              tags={logsList?.tags}
              onSubmit={onSubmit}
              onCancel={() => setFilterModalOpen(false)}/>
    </React.Fragment>
  );

}

const mapStateToProps = (state) => {
  const {AuditLog, Login} = state
  return {...AuditLog, ...Login}
}

export default connect(mapStateToProps, {
  getLogs,
  getLog,
})(Logs);
